
import { useRoute, useRouter } from 'vue-router'
import { defineComponent, onMounted } from 'vue'
import { setToken } from '@/utils/auth'
export default defineComponent({
  setup() {
    // 设置token到localStorage
    const setLoginToken = () => {
      const loginToken = useRoute().query.loginToken as string
      if (loginToken) {
        setToken(loginToken)
      }
    }
    onMounted(() => {
      setLoginToken()
    })
    const router = useRouter()
    const route = useRoute()
    const goVip = () => {
      router.push('1225ActivityPay')
    }
    return {
      goVip,
    }
  },
})
